import service from '../service/common'
import CONSTANT from '../constant/common'
import _ from 'underscore'
export default {
    getSmsCode ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getSmsCode(data).then(result => {
                resolve(result)
                commit(CONSTANT.COMMON_GETSMSCODE_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COMMON_GETSMSCODE_ERROR, e)
            })
        })
    },
    getUserInfo ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getUserInfo(data).then(result => {
                resolve(result)
                commit(CONSTANT.COMMON_GETUSERINFO_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COMMON_GETUSERINFO_ERROR, e)
                commit('rootApperError', e)
            })
        })
    },
    getCaptcha ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getCaptcha(data).then(result => {
                resolve(result)
                commit(CONSTANT.COMMON_GETCAPTCHA_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COMMON_GETCAPTCHA_ERROR, e)
                commit('rootApperError', e)
            })
        })
    },
    isFollowedWechat ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.isFollowedWechat(data).then(result => {
                resolve(result)
                commit(CONSTANT.COMMON_ISFOLLOWEDWECHAT_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COMMON_ISFOLLOWEDWECHAT_ERROR, e)
                // commit('rootApperError', e)
            })
        })
    },
    sendWechatMsgTpl ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.sendWechatMsgTpl(data).then(result => {
                resolve(result)
                commit(CONSTANT.COMMON_SENDWECHATMSGTPL_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COMMON_SENDWECHATMSGTPL_ERROR, e)
                commit('rootApperError', e)
            })
        })
    },
    uploadImage ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.uploadImage(data).then(result => {
                resolve(result)
                return result
            }, e => {
                reject(e)
            })
        })
    },
  generateActionText({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.generateActionText(data).then(result => {
        resolve(result)
        return result
      }, e => {
        reject(e)
      })
    })
  },
    /*yeoman-template-point-1*/
}
